import apiService from './apiService';

export const getCallLogs = async (phoneNumber) => {
  try {
    const response = await apiService.get(`/call-logs/${phoneNumber}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching call logs:', error);
    throw error;
  }
};

export default {
  getCallLogs,
};